import React from 'react'

const PortfolioItem = ({portfolio}) => (
    <div className="portfolio-item">
        <div className="portfolio-item__thumbnail">
            <div className="portfolio-item__thumbnail-overlay">
                <div className="portfolio-item__thumbnail-content">
                    <h4 className="portfolio-item__thumbnail-title">{ portfolio.title }</h4>
                    <p className="portfolio-item__thumbnail-subtitle">{ portfolio.company }</p>
                    <a href={ portfolio.websiteUrl }  target="_blank" rel="noreferrer" aria-label="portfolio link"><i className="icofont-link icofont-lg"></i></a>    
                </div>
                <button className="portfolio-item__thumbnail-button" aria-label="show portfolio button">
                    <i className="icofont-long-arrow-right icofont-2x ml-1"></i>
                </button>
            </div>
            <img src={ portfolio.thumbnailImage.fluid.src } alt="Portfolio Item" />
        </div>
        <div className="portfolio-item__details">
            <button type="button" className="portfolio-item__details-back-button" aria-label="close portfolio button">
                <i className="icofont-long-arrow-left icofont-3x"></i>
            </button>
            <div className="portfolio-item__details-content">
                <div className="portfolio-item__details-img">
                    <div>
                        <div className="portfolio-item__details-heading-wrap">
                            <h4 className="font-bold text-2xl md:text-4xl">{ portfolio.title }</h4>
                            <a href={ portfolio.websiteUrl } className="text-gray-200">{ portfolio.websiteUrl }</a>
                        </div>
                        <div className="portfolio-item__details-img-bg"></div>
                        <img src={ portfolio.image.fluid.src } alt="Portfolio Primary" className="w-full"/>
                    </div>
                </div>
                <div className="portfolio-item__details-text">
                    <h4 className="font-bold font-primary mb-4 mt-8 text-xl fade-up">Project Overview</h4>
                    <div className="fade-up" dangerouslySetInnerHTML={{ __html: portfolio.overview.childContentfulRichText.html }}></div>
                    <h5 className="font-bold font-primary mb-4 mt-6 text-xl fade-up">Tech Stack</h5>
                    <ul className="fade-up">
                        {
                            portfolio.techStack.map((stack, index) => (
                                <li key={ index }>- {stack}</li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    </div> 
);

export default PortfolioItem;